export const textlengthLimit = (text: string, lengthLimit: number, splitWords = false) => {
  if (!text || text.length <= lengthLimit) {
    return text;
  }
  if (!splitWords) {
    text = text.substring(0, text.lastIndexOf(' '));
  }
  text = text.substring(0, lengthLimit - 3);
  return `${text}...`;
};
